export default __webpack_public_path__ + "static/media/logoLine.bc282d39.webp";